module.exports = "<pre>{{inputParameters.value | json}}</pre>"